import { OptionsIcon } from "assets/icons/OptionsIcon";
import { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";

export function GenericTableDropdownActions({ children }: {
  children:
    | ReactElement<typeof Dropdown.Item>
    | ReactElement<typeof Dropdown.Item>[];
})
{
  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon/>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        { children }
      </Dropdown.Menu>
    </Dropdown>
  )
}
